import admin from './admin'
import employee from './employee'
import common from './common'

export default {
  admin,
  employee,
  common,
} as const
